/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import Banners from "../../Components/Banner/Banners";
import AccountPanel from "../../Components/Collection/AccountPanel";
import { rootContext } from "../../context/RootContext";
import { useLocation, useNavigate } from "react-router-dom";
import SubscribeBanner from "../../Components/Banner/SubscribeBanner";
import useSubscription from "../../hooks/useSubscription";
// import { profileDataServce } from "../../services/authService";
import { getSubecriptions } from "../../services/subscriptionService";

const MyAccount = () => {
  const { bannerTitle } = useContext(rootContext);
  const { isSubscribed } = useSubscription();
  const [ispro, setPro] = useState("");
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
  }, []);
  const GetProfile = async () => {
    const result = await getSubecriptions();
    setPro(result?.subscription?.plan?.name);
    // console.log(result?.subscription?.plan?.name)
  };
  useEffect(() => {
    GetProfile();
  }, []);

  return (
    <>
      <Banners name={bannerTitle === "" ? "My Account" : bannerTitle} />

      {isSubscribed === null ? <SubscribeBanner /> : null}
      <AccountPanel ispro={ispro} isRequestColletion={state} />
    </>
  );
};

export default MyAccount;
